module.exports = __webpack_public_path__ + "media/images/voice10-d2decd43ea50ad6bef75327f4aa2a496.jpg";